import React from "react";
import Config from "../../utils/config";
import { Card, CardBody } from "reactstrap";
import "../../assets/scss/components/MainBannerPage/index.scss";
import LandingPage from "../LandingPage";
import { useSelector } from "react-redux";
import ActivityToursLandingPage from "../ActivityToursLandingPage";
import AdminJourneyPage from "../AdminJourneyPage";

const HomeScreen = (props) => {
  const { usertype } = useSelector((state) => state.Auth);
  console.log("aaa", props.toggle);
  return (
    <React.Fragment>
      {usertype && usertype === "Admin" && props.toggle === false ? (
        <LandingPage />
      ) : usertype && usertype === "Admin" && props.toggle === true ? (
        <AdminJourneyPage />
      ) : usertype && usertype === "EU Tours Admin" ? (
        <AdminJourneyPage />
      ) : usertype && usertype === "EU Tours Partner" ? (
        <ActivityToursLandingPage />
      ) : (
        <div
          className="d-flex justify-content-center align-items-center home-container"
          style={{
            backgroundImage: `url(${Config.imageBaseUrl}/EU0001/node/assets/dashboard/riders-portal/login-banner.webp)`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <div className="overlay"></div>
          <Card>
            <CardBody>
              <div className="largecontent">
                <img
                  className="logo"
                  src={`${Config.imageBaseUrl}/EU0001/node/assets/dashboard/riders-portal/riders-club.png`}
                  alt="logo"
                />
              </div>
            </CardBody>
          </Card>
        </div>
      )}
    </React.Fragment>
  );
};

export default HomeScreen;
